import { Logger } from '@tectonic/logger';
import { trackEvent } from './event';

import type { AnalyticsEventPayload } from '../types';

const maskEmail = (email: string): string => {
  const saneEmailChars: string[] = []
  try {
    const emailChars = email.split('')
    const len = emailChars.indexOf('@');
    emailChars.forEach((item, pos) => ((pos >= 2 && pos <= len - 2) || (len <= 4 && pos < len)) ? saneEmailChars.push('*') : saneEmailChars.push(item))
  } catch (error) {
    Logger.error("Error in sanitizing input", error)
  }
  return saneEmailChars.join("")
}

const maskPhoneNumber = (phoneNumber: string): string => {
  let sanePhoneNumber = ""
  try {
    const phoneNumberDigits = phoneNumber.slice(-5);
    sanePhoneNumber = phoneNumberDigits.padStart(phoneNumber.length, '*');
  } catch (error) {
    Logger.error("Error in sanitizing input", error)
  }
  return sanePhoneNumber
}

const trackAuthEvent = (event: string, payload: AnalyticsEventPayload) => {
  // Drop password
  try {
    const { password, ...rest } = payload;
    trackEvent(event, rest);
  } catch (error) {
    Logger.error("Error in sending auth event", error)
  }
};

export { maskEmail, maskPhoneNumber, trackAuthEvent };

